<div id="addPresentationModal">
  <div class="tw-flex tw-justify-end tw-mr-2">
    <button
      type="button"
      mat-icon-button
      class="close"
      (click)="dismiss()"
      aria-label="Close this modal"
    >
      <streamline-icon name="close" width="12" height="12"></streamline-icon>
    </button>
  </div>
  <h4 class="tw-text-center tw-mb-4">Select Presentations</h4>
  <p class="tw-text-left tw-text-gray-700 tw-pl-8 tw-mb-0">
    Choose the presentations that you would like to play in this playlist.
  </p>
  <mat-dialog-content>
    <search-filter
      [filterConfig]="filterConfig"
      [search]="search"
      [doSearch]="presentations.doSearch"
    ></search-filter>
    <div
      class="tw-flex tw-flex-col tw-gap-4 tw-px-[16px] tw-border-solid tw-border-0 tw-border-t tw-border-gray-200 tw-mt-4"
    >
      <folder-path
        [folderTree]="folderService.folderTree"
        [folderId]="search.folderId"
        (folderClicked)="onFolderClicked($event)"
        rootName="Presentations"
      ></folder-path>
    </div>
    <div
      class="scrollable-list tw-mt-4"
      scrollingList
      (scrollEndEvent)="presentations.load()"
      rvSpinner="presentation-list-loader"
      [rvShowSpinner]="isLoading"
    >
      <table id="presentationListTable" class="table table--hover">
        <thead class="table-header">
          <tr class="table-header__row">
            <th class="table-header__cell">
              <mat-checkbox
                [ngModel]="areAllPresentationsSelected()"
                (change)="selectAll($event.checked)"
              ></mat-checkbox>
            </th>
            <th
              id="tableHeaderName"
              (click)="presentations.sortBy('name')"
              class="table-header__cell u_clickable"
            >
              Name
              <!-- ngIf: search.sortBy == 'name' -->
              @if (search.sortBy === 'name') {
                <i
                  [attr.aria-label]="
                    search.reverse ? 'Descending order' : 'Ascending order'
                  "
                  class="fa"
                  [ngClass]="
                    { false: 'fa-caret-up', true: 'fa-caret-down' }[
                      search.reverse
                    ]
                  "
                ></i>
              }
              <!-- end ngIf: search.sortBy == 'name' -->
            </th>
            <th id="tableHeaderStatus" class="table-header__cell">Status</th>
          </tr>
        </thead>
        <tbody class="table-body">
          @for (item of items; track item) {
            @if (item.isFolder) {
              <tr class="table-body__row" (click)="onFolderClicked(item.id)">
                <td class="table-body__cell">
                  <mat-icon
                    svgIcon="folder"
                    class="tw-text-gray-500 tw-ml-[8px] tw-mt-2"
                  />
                </td>
                <td class="table-body__cell">
                  <div class="flex-row">
                    <a
                      role="button"
                      tabindex="0"
                      (click)="
                        $event.stopPropagation(); onFolderClicked(item.id)
                      "
                      (keydown.enter)="onFolderClicked(item.id)"
                      (keydown.space)="
                        $event.preventDefault(); onFolderClicked(item.id)
                      "
                      class="u_ellipsis-lg !tw-text-black"
                      [attr.aria-label]="'Open folder ' + item.name"
                    >
                      <strong>{{ item.name }}</strong>
                    </a>
                  </div>
                </td>
                <td class="table-body__cell text-right"></td>
              </tr>
            } @else {
              <tr
                class="table-body__row u_clickable"
                (click)="presentations.select(item)"
              >
                <td class="table-body__cell">
                  <mat-checkbox
                    class="tw-ml-1"
                    [ngModel]="item.selected"
                    (change)="
                      $event.stopPropagation(); presentations.select(item)
                    "
                  ></mat-checkbox>
                </td>
                <td class="table-body__cell">
                  <div class="flex-row">
                    <a
                      id="presentationName"
                      class="u_ellipsis-lg !tw-text-black"
                      ><strong>{{ item.name }}</strong></a
                    >
                  </div>
                </td>
                <td class="table-body__cell">
                  <status-badge [status]="item.revisionStatusName" />
                </td>
              </tr>
            }
          }
          <!-- If no presentation available -->
          <tr
            class="table-body__row"
            [shown]="
              !presentations.loadingItems && items.length === 0 && !search.query
            "
          >
            <td colspan="3" class="text-center">
              Add a presentation to start communicating better with your
              audience!
            </td>
          </tr>
          <!-- If no search results -->
          <tr
            class="table-body__row"
            [shown]="items.length === 0 && search.query"
          >
            <td colspan="3" class="text-center">
              Your search didn't return any results.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="tw-mt-2 tw-gap-4 tw-pt-8">
    <button matButton="outlined" id="cancel" type="button" (click)="dismiss()">
      Cancel
    </button>
    <button
      id="selectPresentations"
      mat-flat-button
      color="primary"
      type="submit"
      class="tw-w-full md:!tw-w-fit"
      (click)="add()"
      [disabled]="!presentations?.getSelected().length"
    >
      Add Selected
    </button>
  </mat-dialog-actions>
</div>
